import React from "react";
import { Box, Typography, Container, Divider } from "@mui/material";

const AboutUs = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 6, mb: 6 }}>
      <Typography
        variant="h4"
        align="center"
        fontWeight={700}
        sx={{ mb: 3 }}
      >
        About JEMINS Builders & Developers Private Limited
      </Typography>

      <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.6 }}>
        Welcome to <strong>Jemin’s</strong> — your trusted partner in property
        discovery and real estate solutions. At Jemin’s, we believe finding
        your dream property should be simple, transparent, and enjoyable.
      </Typography>

      <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.6 }}>
        Whether you’re searching for residential plots, apartments, villas,
        commercial spaces, or investment opportunities, we bring you a curated
        collection of listings backed by genuine details and verified
        information.
      </Typography>

      <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.6 }}>
        Our mission is to provide a seamless experience for buyers, sellers,
        and investors by combining cutting-edge technology with deep market
        knowledge and exceptional customer service.
      </Typography>

      <Divider sx={{ my: 3 }} />

      <Typography variant="h5" fontWeight={600} sx={{ mb: 2 }}>
        Our Vision
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.6 }}>
        To be the most trusted real estate platform, empowering people to make
        confident property decisions with clarity and convenience.
      </Typography>

      <Typography variant="h5" fontWeight={600} sx={{ mb: 2 }}>
        Our Values
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.6 }}>
        <strong>Transparency:</strong> Clear, honest information in every
        listing.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.6 }}>
        <strong>Trust:</strong> We build lasting relationships with clients and
        partners.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.6 }}>
        <strong>Customer-Centricity:</strong> Your needs always come first.
      </Typography>

      <Divider sx={{ my: 3 }} />

      <Typography variant="h5" fontWeight={600} sx={{ mb: 1 }}>
        Contact Us
      </Typography>
      <Typography variant="body1" sx={{ lineHeight: 1.6 }}>
        Have questions? We’re here to help!
        <br />
        Email: <a href="mailto:jemins_realmart@jemins.in">jemins_realmart@jemins.in</a>
        <br />
        Phone: +91 96296 11466
      </Typography>
    </Container>
  );
};

export default AboutUs;